const initialState = {
    session:{},
    showLoading: false
}
function coreReducer(state = initialState, action){
    switch(action.type){
        case 'UPDATE_SESSION':
            let session = state.session;
            session[action.key] = action.value;
            return {
                ...state,
                session: session
            }
            return state;
        break;
        case 'SHOW_LOADING':
            return {
                ...state,
                showLoading: action.value
            }
        break;
        case 'CLEAR_DATA': 
            return initialState   
        break;     
        default:
            return state;
        break;
    }
}

export default coreReducer;